import clsx from 'clsx';
import dayjs from 'dayjs';
import dayjsTimezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { useEffect, useState } from 'react';

dayjs.extend(utc);
dayjs.extend(dayjsTimezone);
interface Props {
  timezone: string;
  className?: string;
}

const timeFormat = 'ddd HH:mm:ss, D-MMM-YY';

export function LiveClock(props: Props) {
  const { timezone, className } = props;
  const [time, setTime] = useState(dayjs().tz(timezone).format(timeFormat));
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(dayjs().tz(timezone).format(timeFormat));
    }, 1000);

    return () => clearInterval(interval);
  }, [timezone]);

  return (
    <div
      className={clsx(
        'dark:text-ondark-text-2 text-onlight-text-2 space-x-2 text-xs',
        className ?? ''
      )}
    >
      <span>{time}</span>
      <span>({timezone})</span>
    </div>
  );
}
